import React, { FC } from 'react';

export const AttachIcon: FC<any> = props => (
  <svg height="15.682" viewBox="0 0 14.811 15.682" width="14.811" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M300.8,438.151l-5.189,5.189a1.575,1.575,0,1,0,2.228,2.228l5.053-5.189a3.151,3.151,0,0,0-4.456-4.456l-5.054,5.188a4.728,4.728,0,1,0,6.686,6.686l4.93-4.919"
      fill="none"
      id="Path_651"
      stroke="#7f7f7f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      transform="translate(-291.25 -434.25)"
    />
  </svg>
);
